import { render, staticRenderFns } from "./FooterIcon.vue?vue&type=template&id=2ad7b543&scoped=true&"
import script from "./FooterIcon.vue?vue&type=script&lang=js&"
export * from "./FooterIcon.vue?vue&type=script&lang=js&"
import style0 from "./FooterIcon.vue?vue&type=style&index=0&id=2ad7b543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7b543",
  null
  
)

export default component.exports